<template>
<el-container>
    <el-main>
        <el-col :span="24">
            <Tffig2 :species="species" :tissue="tissue" />
        </el-col>
        <el-col :span="24">
            <Tffig1 :species="species" :tf="tf" />
        </el-col>
        <el-col :span="24">
            <Tffig :species="species" :tissue="tissue" :tf="tf" />
        </el-col>
        <el-col :span="24">
            <Tflist :species="species" :tissue="tissue" :tf="tf" />
        </el-col>
    </el-main>
</el-container>
</template>

<script>
import Tffig1 from './Tffig1.vue';
import Tffig from './Tffig.vue';
import Tflist from './Tflist.vue';
import Tffig2 from './Tffig2.vue';

export default {
    components: {
        Tffig,Tffig1,Tflist,Tffig2
    },
    props: {
        species: {
            type: String,
            required: true,
        },
        tissue: {
            type: [String, Array],
            required: true,
        },
        tf: {
            type: String,
            required: true,
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/home/Tfpanel.vue